module.exports = __webpack_public_path__ + "static/media/36-9.f513e020.mp3";